export const getTranslations = (content: any) => {
  if (content) {
    return {
      pageTitle: content.pageTitle ?? "Welcome to HSC",
      bodyText: content.bodyText ?? "Some shit bodyText",
    };
  }
  return;
};
